import { useEffect, useState } from 'react'
import { useApiCall } from '../../../component/custom-hooks/api-call';
import { card, EditableCell, EmojiField, Section } from '.';
import { set } from 'date-fns';
import { tr } from 'date-fns/locale';
import InnerLoader from '../../../component/ui/loader/inner-loader';
import DataNotFound from '../../../component/ui/loader/data-not-found';
import { Folder } from 'lucide-react';

const Categories = ({ toast = () => { }, inpStyle, C }) => {
    const apiCall = useApiCall();
    const selStyle = { ...inpStyle, cursor: "pointer" };
    const [isLoading, setIsLoading] = useState(true);
    // Category actions
    const [categories, setCategories] = useState([]);
    const [modalCategory, setModalCategory] = useState(null);
    const [categoryForm, setCategoryForm] = useState({});
    const openNewCategory = () => {
        setCategoryForm({ name: "", icon: "🏢", is_active: true });
        setModalCategory(true);
    };

    const fetchCategories = async () => {
        setIsLoading(true);
        try {
            const res = await apiCall({ url: "cash-flow/categories/list", method: "GET" });
            setCategories(res.data || []);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const updateCat = async (id, field, val) => {
        // Extract value if it's an event object
        const value = val?.target?.value !== undefined ? val.target.value : val;

        const newdata = categories.map(c => c.id === id ? { ...c, [field]: value } : c);
        setCategories(newdata);
        const updatedCategory = newdata.find(c => c.id === id);
        try {
            await apiCall({
                url: `cash-flow/categories/update`,
                method: "POST",
                data: updatedCategory
            });
            toast("Category updated", "success");
        } catch (error) {
            console.error("Error updating category:", error);
        }
    };

    const addCategory = async () => {
        try {
            const res = await apiCall({
                url: "cash-flow/categories/add",
                method: "POST",
                data: categoryForm
            });
            toast("Category added", "success");
            setModalCategory(false);
            setCategoryForm({});
            fetchCategories();
        } catch (error) {
            toast(error?.response?.data?.message || "Error adding category", "error");
        }
    };

    const toggleCatActive = async (id) => {
        // Update local state immediately
        const newdata = categories.map(c => c.id === id ? { ...c, is_active: !c.is_active } : c);
        setCategories(newdata);

        try {
            await apiCall({
                url: `cash-flow/categories/${id}/update-status`,
                method: "POST",
            });
            toast("Category updated", "success");
            // Don't refetch - local state is already updated
        } catch (error) {
            console.error("Error toggling category active status:", error?.message || error);
            toast("Error updating category", "error");
            // Revert local change on error
            fetchCategories();
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    return (
        <Section
            id="categories"
            icon={<Folder size={18} />}
            title="Categories"
            desc="Expense categories — drag to reorder, click name to rename"
            C={C}
            card={card}
            Btn={
                <button onClick={() => { openNewCategory() }}
                    style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 16px", borderRadius: 9, border: `1px dashed ${C.border}`, background: "#f9fafb", fontSize: 12, fontWeight: 600, color: C.textSec, cursor: "pointer" }}>
                    + Add Category
                </button>
            }
        >
            {isLoading ? (
                <div className="w-full h-[420px] flex items-center justify-center">
                    <InnerLoader />
                </div>
            ) : categories.length < 1 ? (
                <div className="w-full h-[420px] flex items-center justify-cente pb-5">
                    <DataNotFound title={"categories"} />
                </div>
            ) : (
                <div className='grid grid-cols-2 gap-[12px]' style={{ marginBottom: 14 }}>
                    {[...categories].map((cat) => (
                        <div key={cat.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", borderRadius: 10, border: `1px solid ${cat.is_active ? C.border : "#e5e7eb"}`, background: cat.is_active ? "#FAFAF9" : "#f9fafb", opacity: cat.is_active ? 1 : 0.55 }}>
                            <span style={{ fontSize: 16, flexShrink: 0, width: 22, textAlign: "center" }}>
                                <EditableCell type='emoji' value={cat.icon} onSave={v => updateCat(cat.id, "icon", v)} placeholder="X" style={{ fontSize: 16, width: 40, textAlign: "center" }} />
                            </span>
                            <div style={{ flex: 1 }}>
                                <EditableCell value={cat.name} onSave={v => { updateCat(cat.id, "name", v); toast("Category renamed", "success"); }} style={{ fontSize: 12.5, fontWeight: 600, color: C.textPri }} />
                            </div>

                            {/* <EditableCell value={cat.icon} onSave={v => updateCat(cat.id, "icon", v)} placeholder="emoji" style={{ fontSize: 16, width: 40, textAlign: "center" }} /> */}
                            {/* Reorder */}
                            {/* <div style={{ display: "flex", gap: 2, flexShrink: 0 }}>
                            <button onClick={() => moveCat(cat.id, -1)} disabled={i === 0}
                                style={{ width: 24, height: 24, borderRadius: 6, border: `1px solid ${C.border}`, background: "#f9fafb", cursor: i === 0 ? "not-allowed" : "pointer", fontSize: 11, color: C.textMut, opacity: i === 0 ? 0.3 : 1 }}>↑</button>
                            <button onClick={() => moveCat(cat.id, 1)} disabled={i === arr.length - 1}
                                style={{ width: 24, height: 24, borderRadius: 6, border: `1px solid ${C.border}`, background: "#f9fafb", cursor: i === arr.length - 1 ? "not-allowed" : "pointer", fontSize: 11, color: C.textMut, opacity: i === arr.length - 1 ? 0.3 : 1 }}>↓</button>
                        </div> */}
                            {/* <button onClick={() => { toggleCatActive(cat.id); }}
                                style={{ padding: "3px 10px", borderRadius: 20, border: `1px solid ${cat.is_active ? "#fecaca" : C.border}`, background: cat.is_active ? "#fef2f2" : "#f0fdf4", fontSize: 10, fontWeight: 600, color: cat.is_active ? C.red : C.green, cursor: "pointer", whiteSpace: "nowrap" }}>
                                {cat.is_active ? "Hide" : "Show"}
                            </button> */}
                            <label className="relative inline-flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    className="sr-only peer"
                                    checked={cat.is_active}
                                    onChange={() => { toggleCatActive(cat.id); }}
                                />

                                {/* Background */}
                                <div className="w-12 h-7 bg-[rgba(0,0,0,0.55)] rounded-full peer peer-checked:bg-black transition-colors"></div>

                                {/* Circle */}
                                <div className="absolute left-1 top-1 w-5 h-5 bg-white rounded-full transition-transform peer-checked:translate-x-5"></div>
                            </label>
                        </div>
                    ))}
                </div>
            )}


            {/* Category modal */}
            {modalCategory && (
                <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 400, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
                    <div style={{ background: "#fff", borderRadius: 16, padding: "24px", width: "100%", maxWidth: 460 }} onClick={e => e.stopPropagation()}>
                        <h3 style={{ margin: "0 0 18px", fontSize: 16, fontWeight: 800, color: C.textPri }}>
                            Add Category
                        </h3>

                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 10, fontWeight: 700, color: C.textMut, letterSpacing: 0.5, textTransform: "uppercase", marginBottom: 5 }}>
                                Category Name
                            </div>
                            <input type={'text'} value={categoryForm.name} onChange={e => setCategoryForm({ ...categoryForm, name: e.target.value })} placeholder={"Category name"} style={{ ...inpStyle, width: "100%" }} />
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
                            <div style={{ position: "relative" }}>
                                <EmojiField
                                    value={categoryForm.icon}
                                    onChange={e => setCategoryForm({ ...categoryForm, icon: `${e}` })}
                                    C={C}
                                    style={{ ...inpStyle, width: "100%", paddingRight: 30, paddingTop: 7, paddingBottom: 7, fontSize: 12 }}
                                />
                            </div>

                            <div>
                                <div style={{ fontSize: 10, fontWeight: 700, color: C.textMut, letterSpacing: 0.5, textTransform: "uppercase", marginBottom: 5 }}>Status</div>
                                <select value={categoryForm.is_active} onChange={e => setCategoryForm({ ...categoryForm, is_active: e.target.value === "true" })} style={{ ...selStyle, width: "100%" }}>
                                    <option value={true}>Active</option>
                                    <option value={false}>Inactive</option>
                                </select>
                            </div>
                        </div>

                        <div style={{ display: "flex", gap: 8 }}>
                            <button
                                onClick={() => setModalCategory(null)}
                                style={{ flex: 1, padding: "9px", borderRadius: 9, border: `1px solid ${C.border}`, background: "#fff", fontSize: 13, cursor: "pointer", color: C.textSec }}
                            >
                                Cancel
                            </button>

                            <button onClick={addCategory}
                                style={{ flex: 1, padding: "9px", borderRadius: 9, border: "none", background: C.accent, fontSize: 13, fontWeight: 700, color: "#fff", cursor: "pointer" }}>
                                Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Section>
    )
}

export default Categories
